// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseUrl: "http://localhost:8080" | "https://app.octalog.de" | (string & {});
};

export type AddContentRequestDto = {
  cuttingLength: CuttingLength;
  fillingDate: string;
  humidityLevel: HumidityLevel;
  level?: number;
  woodType: WoodType;
};

export type AddressResponseDto = {
  addition?: string;
  addressId: number;
  addressType: ContactDetailAddressType;
  city?: string;
  country: string;
  postalCode?: string;
  street?: string;
};

export type ApiErrorContainer = {
  code: string;
  details: Array<ApiErrorDetail>;
  message: string;
  metadata: ResponseMetadata;
  status: DefaultHttpStatusCode | HttpStatus;
};

export type ApiErrorDetail = {
  detailMessages: Array<string>;
};

export type ApiResponseContactSyncResultDto = {
  data: ContactSyncResultDto;
  metadata: ResponseMetadata;
};

export type ApiResponseExternalSystemSettingsResponseDto = {
  data: ExternalSystemSettingsResponseDto;
  metadata: ResponseMetadata;
};

export type ApiResponseInteger = {
  data: number;
  metadata: ResponseMetadata;
};

export type ApiResponseListArticleDto = {
  data: Array<ArticleDto>;
  metadata: ResponseMetadata;
};

export type ApiResponseListExternalSystemSettingsResponseDto = {
  data: Array<ExternalSystemSettingsResponseDto>;
  metadata: ResponseMetadata;
};

export type ApiResponseListOrderDeliveryScheduleDto = {
  data: Array<OrderDeliveryScheduleDto>;
  metadata: ResponseMetadata;
};

export type ApiResponseListOrderDto = {
  data: Array<OrderDto>;
  metadata: ResponseMetadata;
};

export type ApiResponseOrderDto = {
  data: OrderDto;
  metadata: ResponseMetadata;
};

export type ApiResponseString = {
  data: string;
  metadata: ResponseMetadata;
};

export type ApiResponseUnit = {
  metadata: ResponseMetadata;
};

export type AreaListResponseDto = {
  areas: Array<AreaResponseDto>;
};

export type AreaResponseDto = {
  areaId: number;
  name: string;
};

export type AreaStatistics = {
  containerCountByArea: Array<ContainerCountByArea>;
  sum: number;
  volumeByArea: Array<VolumeByArea>;
};

export type ArticleDto = {
  description?: string;
  name: string;
  price?: number;
  sku: string;
};

export type AssignContainersToAreaDto = {
  containerIds: Array<number>;
};

export type CompanyContactCreateDto = {
  companyName: string;
};

export type CompanyContactResponseDto = {
  companyName: string;
};

export type ConfirmationMailDto = {
  name: string;
  to: string;
  token: string;
};

export type ContactCreateDto = {
  addresses: Array<CreateAddressDto>;
  companyContact?: CompanyContactCreateDto;
  contactIdentifierCustomer?: CreateContactIdentifierCustomerDto;
  contactIdentifierSupplier?: CreateContactIdentifierSupplierDto;
  contactType: ContactType;
  emails: Array<CreateEmailDto>;
  externalReference?: ExternalReferenceDto;
  individualContact?: IndividualContactCreateDto;
  note?: string;
  phoneNumbers: Array<CreatePhoneNumberDto>;
};

export enum ContactDetailAddressType {
  INVOICE = "INVOICE",
  DELIVERY = "DELIVERY",
}

export enum ContactDetailEmailType {
  BUSINESS = "BUSINESS",
  OFFICE = "OFFICE",
  PRIVATE = "PRIVATE",
  OTHER = "OTHER",
}

export enum ContactDetailPhoneNumberType {
  BUSINESS = "BUSINESS",
  OFFICE = "OFFICE",
  MOBILE = "MOBILE",
  PRIVATE = "PRIVATE",
  FAX = "FAX",
  OTHER = "OTHER",
}

export type ContactIdentifierCustomerResponseDto = {
  customerId: number;
};

export type ContactIdentifierSupplierResponseDto = {
  customerIdAtSupplier?: string;
  supplierId: number;
};

export type ContactResponseDto = {
  addresses: Array<AddressResponseDto>;
  companyContact?: CompanyContactResponseDto;
  contactId: number;
  contactIdentifierCustomer?: ContactIdentifierCustomerResponseDto;
  contactIdentifierSupplier?: ContactIdentifierSupplierResponseDto;
  contactType: ContactType;
  emails: Array<EmailResponseDto>;
  externalReference?: ExternalReferenceDto;
  individualContact?: IndividualContactResponseDto;
  note?: string;
  phoneNumbers: Array<PhoneNumberResponseDto>;
};

export type ContactSyncResultDto = {
  failureCount: number;
  hasFailures: boolean;
  successCount: number;
  totalCount: number;
};

export enum ContactType {
  COMPANY = "Company",
  INDIVIDUAL = "Individual",
}

export type ContainerAddContentBatchDto = {
  containerIds: Array<number>;
  content: AddContentRequestDto;
};

export type ContainerCountByArea = {
  areaId?: number;
  count: number;
};

export type ContainerCountByCuttingLength = {
  count: number;
  cuttingLength: CuttingLength;
};

export type ContainerCountByHumidityLevel = {
  count: number;
  humidityLevel: HumidityLevel;
};

export type ContainerCountByWoodType = {
  count: number;
  woodType: WoodType;
};

export type ContainerEmptyBatchDto = {
  containerIds: Array<number>;
  emptyingDate?: string;
  removeLocation?: boolean;
};

export type ContainerStatisticsDto = {
  areaStatistics: AreaStatistics;
  containerCountEmpty: number;
  containerCountFull: number;
  containerCountSum: number;
  cuttingLengthStatistics: CuttingLengthStatistics;
  humidityLevelStatistics: HumidityLevelStatistics;
  woodTypeStatistics: WoodTypeStatistics;
};

export type ContainerTypeListResponseDto = {
  containerTypes: Array<ContainerTypeResponseDto>;
};

export type ContainerTypeRequestDto = {
  name: string;
  unitOfMeasurement: UnitOfMeasurement;
  volume: number;
};

export type ContainerTypeResponseDto = {
  containerTypeId: number;
  name: string;
  unitOfMeasurement: UnitOfMeasurement;
  volume: number;
};

export type ContentLevelBatchDto = {
  containerIds: Array<number>;
  date: string;
  eventType: LevelEventType;
  volume: number;
};

export type ContentLevelEventStatisticDto = {
  date: string;
  emptyVolume: number;
  fillVolume: number;
  stockVolume: number;
};

export type ContentLevelEventStatisticsDto = {
  contentLevelEventStatistics: Array<ContentLevelEventStatisticDto>;
  sumEmptyVolume: number;
  sumFillVolume: number;
};

export type CreateAddressDto = {
  addition?: string;
  addressType: ContactDetailAddressType;
  city?: string;
  country: string;
  postalCode?: string;
  street?: string;
};

export type CreateAreaRequestDto = {
  name: string;
};

export type CreateContactIdentifierCustomerDto = {
  customerId?: number;
};

export type CreateContactIdentifierSupplierDto = {
  customerIdAtSupplier?: string;
  supplierId?: number;
};

export type CreateContactResponseDto = {
  contactId: number;
};

export type CreateContainerBatchRequestDto = {
  containers: Array<CreateContainerRequestDto>;
};

export type CreateContainerRequestDto = {
  containerName: string;
  containerTypeId: number;
};

export type CreateEmailDto = {
  email: string;
  emailType: ContactDetailEmailType;
};

export type CreatePhoneNumberDto = {
  phoneNumber: string;
  phoneNumberType: ContactDetailPhoneNumberType;
};

export enum CuttingLength {
  CM25 = "CM25",
  CM33 = "CM33",
}

export type CuttingLengthContainerDto = {
  cuttingLengths: Array<CuttingLengthDto>;
};

export type CuttingLengthDto = {
  /**
   * we want to remove the cuttingLength enum
   *
   * @deprecated
   */
  cuttingLength: CuttingLength;
  cuttingLengthId: number;
  name: string;
};

export type CuttingLengthStatistics = {
  containerCountByCuttingLength: Array<ContainerCountByCuttingLength>;
  sum: number;
  volumeByCuttingLength: Array<VolumeByCuttingLength>;
};

export type DefaultHttpStatusCode = HttpStatusCode;

export type EmailResponseDto = {
  email: string;
  emailId: number;
  emailType: ContactDetailEmailType;
};

export type ExternalReferenceDto = {
  externalSyncId: string;
  externalSyncImportError?: string;
  externalSystem: ExternalSystem;
  externalVersion?: number;
};

export enum ExternalSystem {
  LEXWARE = "LEXWARE",
}

export type ExternalSystemSettingsResponseDto = {
  id: string;
  system: ExternalSystem;
  tokenLength: number;
};

export type GetContainerListResponseDto = {
  containers: Array<GetContainerResponseDto>;
};

export type GetContainerResponseDto = {
  area?: AreaResponseDto;
  containerId: number;
  containerName: string;
  containerType: ContainerTypeResponseDto;
  content?: GetContentResponseDto;
};

export type GetContentResponseDto = {
  contentId: number;
  cuttingLength: CuttingLength;
  fillingDate: string;
  humidityLevel: HumidityLevel;
  level: number;
  woodType: WoodType;
};

export enum HttpStatus {
  "100_CONTINUE" = "100 CONTINUE",
  "101_SWITCHING_PROTOCOLS" = "101 SWITCHING_PROTOCOLS",
  "102_PROCESSING" = "102 PROCESSING",
  "103_EARLY_HINTS" = "103 EARLY_HINTS",
  "200_OK" = "200 OK",
  "201_CREATED" = "201 CREATED",
  "202_ACCEPTED" = "202 ACCEPTED",
  "203_NON_AUTHORITATIVE_INFORMATION" = "203 NON_AUTHORITATIVE_INFORMATION",
  "204_NO_CONTENT" = "204 NO_CONTENT",
  "205_RESET_CONTENT" = "205 RESET_CONTENT",
  "206_PARTIAL_CONTENT" = "206 PARTIAL_CONTENT",
  "207_MULTI_STATUS" = "207 MULTI_STATUS",
  "208_ALREADY_REPORTED" = "208 ALREADY_REPORTED",
  "226_IM_USED" = "226 IM_USED",
  "300_MULTIPLE_CHOICES" = "300 MULTIPLE_CHOICES",
  "301_MOVED_PERMANENTLY" = "301 MOVED_PERMANENTLY",
  "302_FOUND" = "302 FOUND",
  "303_SEE_OTHER" = "303 SEE_OTHER",
  "304_NOT_MODIFIED" = "304 NOT_MODIFIED",
  "307_TEMPORARY_REDIRECT" = "307 TEMPORARY_REDIRECT",
  "308_PERMANENT_REDIRECT" = "308 PERMANENT_REDIRECT",
  "400_BAD_REQUEST" = "400 BAD_REQUEST",
  "401_UNAUTHORIZED" = "401 UNAUTHORIZED",
  "402_PAYMENT_REQUIRED" = "402 PAYMENT_REQUIRED",
  "403_FORBIDDEN" = "403 FORBIDDEN",
  "404_NOT_FOUND" = "404 NOT_FOUND",
  "405_METHOD_NOT_ALLOWED" = "405 METHOD_NOT_ALLOWED",
  "406_NOT_ACCEPTABLE" = "406 NOT_ACCEPTABLE",
  "407_PROXY_AUTHENTICATION_REQUIRED" = "407 PROXY_AUTHENTICATION_REQUIRED",
  "408_REQUEST_TIMEOUT" = "408 REQUEST_TIMEOUT",
  "409_CONFLICT" = "409 CONFLICT",
  "410_GONE" = "410 GONE",
  "411_LENGTH_REQUIRED" = "411 LENGTH_REQUIRED",
  "412_PRECONDITION_FAILED" = "412 PRECONDITION_FAILED",
  "413_CONTENT_TOO_LARGE" = "413 CONTENT_TOO_LARGE",
  "413_PAYLOAD_TOO_LARGE" = "413 PAYLOAD_TOO_LARGE",
  "414_URI_TOO_LONG" = "414 URI_TOO_LONG",
  "415_UNSUPPORTED_MEDIA_TYPE" = "415 UNSUPPORTED_MEDIA_TYPE",
  "416_REQUESTED_RANGE_NOT_SATISFIABLE" = "416 REQUESTED_RANGE_NOT_SATISFIABLE",
  "417_EXPECTATION_FAILED" = "417 EXPECTATION_FAILED",
  "418_I_AM_A_TEAPOT" = "418 I_AM_A_TEAPOT",
  "421_MISDIRECTED_REQUEST" = "421 MISDIRECTED_REQUEST",
  "422_UNPROCESSABLE_CONTENT" = "422 UNPROCESSABLE_CONTENT",
  "422_UNPROCESSABLE_ENTITY" = "422 UNPROCESSABLE_ENTITY",
  "423_LOCKED" = "423 LOCKED",
  "424_FAILED_DEPENDENCY" = "424 FAILED_DEPENDENCY",
  "425_TOO_EARLY" = "425 TOO_EARLY",
  "426_UPGRADE_REQUIRED" = "426 UPGRADE_REQUIRED",
  "428_PRECONDITION_REQUIRED" = "428 PRECONDITION_REQUIRED",
  "429_TOO_MANY_REQUESTS" = "429 TOO_MANY_REQUESTS",
  "431_REQUEST_HEADER_FIELDS_TOO_LARGE" = "431 REQUEST_HEADER_FIELDS_TOO_LARGE",
  "451_UNAVAILABLE_FOR_LEGAL_REASONS" = "451 UNAVAILABLE_FOR_LEGAL_REASONS",
  "500_INTERNAL_SERVER_ERROR" = "500 INTERNAL_SERVER_ERROR",
  "501_NOT_IMPLEMENTED" = "501 NOT_IMPLEMENTED",
  "502_BAD_GATEWAY" = "502 BAD_GATEWAY",
  "503_SERVICE_UNAVAILABLE" = "503 SERVICE_UNAVAILABLE",
  "504_GATEWAY_TIMEOUT" = "504 GATEWAY_TIMEOUT",
  "505_HTTP_VERSION_NOT_SUPPORTED" = "505 HTTP_VERSION_NOT_SUPPORTED",
  "506_VARIANT_ALSO_NEGOTIATES" = "506 VARIANT_ALSO_NEGOTIATES",
  "507_INSUFFICIENT_STORAGE" = "507 INSUFFICIENT_STORAGE",
  "508_LOOP_DETECTED" = "508 LOOP_DETECTED",
  "509_BANDWIDTH_LIMIT_EXCEEDED" = "509 BANDWIDTH_LIMIT_EXCEEDED",
  "510_NOT_EXTENDED" = "510 NOT_EXTENDED",
  "511_NETWORK_AUTHENTICATION_REQUIRED" = "511 NETWORK_AUTHENTICATION_REQUIRED",
}

export type HttpStatusCode = {
  error?: boolean;
  is1xxInformational?: boolean;
  is2xxSuccessful?: boolean;
  is3xxRedirection?: boolean;
  is4xxClientError?: boolean;
  is5xxServerError?: boolean;
};

export enum HumidityLevel {
  WET = "WET",
  PRE_DRIED = "PRE_DRIED",
  DRIED = "DRIED",
}

export type HumidityLevelContainerDto = {
  humidityLevels: Array<HumidityLevelDto>;
};

export type HumidityLevelDto = {
  /**
   * we want to remove the humidityLevel enum
   *
   * @deprecated
   */
  humidityLevel: HumidityLevel;
  humidityLevelId: number;
  name: string;
};

export type HumidityLevelStatistics = {
  containerCountByHumidityLevel: Array<ContainerCountByHumidityLevel>;
  sum: number;
  volumeByHumidityLevel: Array<VolumeByHumidityLevel>;
};

export type IndividualContactCreateDto = {
  firstName?: string;
  lastName: string;
  salutation?: string;
};

export type IndividualContactResponseDto = {
  firstName?: string;
  lastName: string;
  salutation?: string;
};

export enum LevelEventType {
  FILL = "FILL",
  EMPTY = "EMPTY",
}

export type Link = {
  href?: string;
  templated?: boolean;
};

export type OrderCreateDto = {
  contactId: number;
  deliveryAddress?: string;
  deliveryDate?: string;
  deliveryTargetDateEnd?: string;
  deliveryTargetDateStart: string;
  deliveryTargetTimeEnd?: string;
  deliveryTargetTimeStart?: string;
  invoiceAddress: string;
  items: Array<OrderItemArticleCreateDto | OrderItemWoodCreateDto>;
  orderDate: string;
  status?: OrderStatus;
};

export type OrderDeliveryScheduleDto = {
  deliveryDate: string;
  deliveryTime: string;
  /**
   * Duration in ISO-8601 format (e.g., PT1H15M for 1 hour and 15 minutes)
   */
  duration: string;
  orderNumber: string;
};

export type OrderDto = {
  contactId: number;
  deliveryAddress?: string;
  deliveryDate?: string;
  deliverySchedule?: OrderDeliveryScheduleDto;
  deliveryTargetDateEnd?: string;
  deliveryTargetDateStart: string;
  deliveryTargetTimeEnd?: string;
  deliveryTargetTimeStart?: string;
  invoiceAddress: string;
  items: Array<OrderItemArticleDto | OrderItemWoodDto>;
  orderDate: string;
  orderNumber: string;
  status: OrderStatus;
  totalPrice: number;
  totalPriceOverride?: number;
};

export type OrderItemArticleCreateDto = Omit<OrderItemCreateDto, "type"> & {
  description?: string;
  name: string;
  price: number;
  priceOverride?: number;
  quantity: number;
  sku: string;
  type: "OrderItemArticleCreateDto";
};

export type OrderItemArticleDto = Omit<OrderItemDto, "type"> & {
  description?: string;
  name: string;
  price: number;
  priceOverride?: number;
  quantity: number;
  sku: string;
  type: "OrderItemArticleDto";
};

export type OrderItemArticleUpdateDto = Omit<OrderItemUpdateDto, "type"> & {
  description?: string;
  name: string;
  orderItemId?: number;
  price: number;
  priceOverride?: number;
  quantity: number;
  sku: string;
  type: "OrderItemArticleUpdateDto";
};

export type OrderItemCreateDto = {
  price: number;
  priceOverride?: number;
  type: string;
};

export type OrderItemDto = {
  orderItemId: number;
  price: number;
  priceOverride?: number;
  type: string;
};

export type OrderItemUpdateDto = {
  price: number;
  priceOverride?: number;
  type: string;
};

export type OrderItemWoodCreateDto = Omit<OrderItemCreateDto, "type"> & {
  cuttingLengthId: number;
  humidityLevelId: number;
  price: number;
  priceOverride?: number;
  unitOfMeasurement: UnitOfMeasurement;
  volume: number;
  woodTypeId: number;
  type: "OrderItemWoodCreateDto";
};

export type OrderItemWoodDto = Omit<OrderItemDto, "type"> & {
  cuttingLengthId: number;
  humidityLevelId: number;
  price: number;
  priceOverride?: number;
  unitOfMeasurement: UnitOfMeasurement;
  volume: number;
  woodTypeId: number;
  type: "OrderItemWoodDto";
};

export type OrderItemWoodUpdateDto = Omit<OrderItemUpdateDto, "type"> & {
  cuttingLengthId: number;
  humidityLevelId: number;
  orderItemId?: number;
  price: number;
  priceOverride?: number;
  unitOfMeasurement: UnitOfMeasurement;
  volume: number;
  woodTypeId: number;
  type: "OrderItemWoodUpdateDto";
};

export enum OrderStatus {
  NEW = "NEW",
  SCHEDULED = "SCHEDULED",
  IN_DELIVERY = "IN_DELIVERY",
  DELIVERED = "DELIVERED",
  CANCELED = "CANCELED",
  UNSCHEDULED = "UNSCHEDULED",
  RESCHEDULED = "RESCHEDULED",
}

export type OrderUpdateDto = {
  contactId: number;
  deliveryAddress?: string;
  deliveryDate?: string;
  deliveryTargetDateEnd?: string;
  deliveryTargetDateStart: string;
  deliveryTargetTimeEnd?: string;
  deliveryTargetTimeStart?: string;
  invoiceAddress: string;
  items: Array<OrderItemArticleUpdateDto | OrderItemWoodUpdateDto>;
  orderDate: string;
  orderNumber: string;
  status: OrderStatus;
};

export type PasswordResetConfirmationRequestDto = {
  password: string;
  token: string;
};

export type PasswordResetRequestDto = {
  username: string;
};

export type PhoneNumberResponseDto = {
  phoneNumber: string;
  phoneNumberId: number;
  phoneNumberType: ContactDetailPhoneNumberType;
};

export type PriceContainerDto = {
  prices: Array<PriceDto>;
};

export type PriceDto = {
  cuttingLengthId: number;
  humidityLevelId: number;
  price: number;
  priceOverride?: number;
  woodTypeId: number;
};

export type PriceModifierCuttingLengthDto = {
  cuttingLengthId: number;
  value?: number;
};

export type PriceModifierHumidityLevelDto = {
  humidityLevelId: number;
  value?: number;
};

export type PriceModifierWoodTypeDto = {
  value?: number;
  woodTypeId: number;
};

export type PriceOverrideContainerDto = {
  overrides: Array<PriceOverrideDto>;
};

export type PriceOverrideDto = {
  cuttingLengthId: number;
  humidityLevelId: number;
  value: number;
  woodTypeId: number;
};

export type PriceSettingsDto = {
  basePrice?: number;
  priceModifiersCuttingLength: Array<PriceModifierCuttingLengthDto>;
  priceModifiersHumidityLevel: Array<PriceModifierHumidityLevelDto>;
  priceModifiersWoodType: Array<PriceModifierWoodTypeDto>;
};

export type PriceSettingsRequestDto = {
  basePrice?: number;
  priceModifiersCuttingLength: Array<PriceModifierCuttingLengthDto>;
  priceModifiersHumidityLevel: Array<PriceModifierHumidityLevelDto>;
  priceModifiersWoodType: Array<PriceModifierWoodTypeDto>;
};

export type ResponseMetadata = {
  spanId: string;
  timestamp: number;
  traceId: string;
};

export type SignInRequestDto = {
  password: string;
  username: string;
};

export type SignUpRequestDto = {
  companyName: string;
  firstName: string;
  lastName: string;
  password: string;
  username: string;
};

export type StoreExternalSystemSettingsRequestDto = {
  system: ExternalSystem;
  token: string;
};

export enum UnitOfMeasurement {
  SOLID_CUBIC_METER = "SOLID_CUBIC_METER",
  STACKED_CUBIC_METER = "STACKED_CUBIC_METER",
  LOOSE_CUBIC_METER = "LOOSE_CUBIC_METER",
}

export type UpdateContainerRequestDto = {
  areaId?: number;
  containerName?: string;
  containerType?: UpdateContainerTypeRequestDto;
  content?: UpdateContentRequestDto;
};

export type UpdateContainerTypeRequestDto = {
  adjustLevel: boolean;
  containerTypeId: number;
};

export type UpdateContentRequestDto = {
  cuttingLength: CuttingLength;
  humidityLevel: HumidityLevel;
  woodType: WoodType;
};

export type UpdateExternalSystemSettingsRequestDto = {
  token: string;
};

export type UserDto = {
  email: string;
  firstName: string;
  lastName: string;
  roles: Array<string>;
  tenantId: number;
  userId: number;
};

export type VersionResponseDto = {
  buildVersion: string;
  octalogVersion: string;
};

export type VolumeByArea = {
  areaId?: number;
  volume: number;
};

export type VolumeByCuttingLength = {
  cuttingLength: CuttingLength;
  volume: number;
};

export type VolumeByHumidityLevel = {
  humidityLevel: HumidityLevel;
  volume: number;
};

export type VolumeByWoodType = {
  volume: number;
  woodType: WoodType;
};

export enum WoodType {
  BEECH = "BEECH",
  OAK = "OAK",
  SPRUCE = "SPRUCE",
  ASH = "ASH",
  LARCH = "LARCH",
}

export type WoodTypeContainerDto = {
  woodTypes: Array<WoodTypeDto>;
};

export type WoodTypeDto = {
  name: string;
  /**
   * we want to remove the woodType enum
   *
   * @deprecated
   */
  woodType: WoodType;
  woodTypeId: number;
};

export type WoodTypeStatistics = {
  containerCountByWoodType: Array<ContainerCountByWoodType>;
  sum: number;
  volumeByWoodType: Array<VolumeByWoodType>;
};

export type LinksData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/actuator";
};

export type LinksErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type LinksError = LinksErrors[keyof LinksErrors];

export type LinksResponses = {
  /**
   * OK
   */
  200: {
    [key: string]: {
      [key: string]: Link;
    };
  };
};

export type LinksResponse = LinksResponses[keyof LinksResponses];

export type HealthData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/actuator/health";
};

export type HealthErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type HealthError = HealthErrors[keyof HealthErrors];

export type HealthResponses = {
  /**
   * OK
   */
  200: {
    [key: string]: unknown;
  };
};

export type HealthResponse = HealthResponses[keyof HealthResponses];

export type InfoData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/actuator/info";
};

export type InfoErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type InfoError = InfoErrors[keyof InfoErrors];

export type InfoResponses = {
  /**
   * OK
   */
  200: {
    [key: string]: unknown;
  };
};

export type InfoResponse = InfoResponses[keyof InfoResponses];

export type GetAreasData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/areas";
};

export type GetAreasErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetAreasError = GetAreasErrors[keyof GetAreasErrors];

export type GetAreasResponses = {
  /**
   * OK
   */
  200: AreaListResponseDto;
};

export type GetAreasResponse = GetAreasResponses[keyof GetAreasResponses];

export type CreateAreaData = {
  body: CreateAreaRequestDto;
  path?: never;
  query?: never;
  url: "/api/areas";
};

export type CreateAreaErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type CreateAreaError = CreateAreaErrors[keyof CreateAreaErrors];

export type CreateAreaResponses = {
  /**
   * OK
   */
  200: AreaResponseDto;
};

export type CreateAreaResponse = CreateAreaResponses[keyof CreateAreaResponses];

export type GetAreaByIdData = {
  body?: never;
  path: {
    areaId: number;
  };
  query?: never;
  url: "/api/areas/{areaId}";
};

export type GetAreaByIdErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetAreaByIdError = GetAreaByIdErrors[keyof GetAreaByIdErrors];

export type GetAreaByIdResponses = {
  /**
   * OK
   */
  200: AreaResponseDto;
};

export type GetAreaByIdResponse = GetAreaByIdResponses[keyof GetAreaByIdResponses];

export type UpdateAreaData = {
  body: CreateAreaRequestDto;
  path: {
    areaId: number;
  };
  query?: never;
  url: "/api/areas/{areaId}";
};

export type UpdateAreaErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type UpdateAreaError = UpdateAreaErrors[keyof UpdateAreaErrors];

export type UpdateAreaResponses = {
  /**
   * OK
   */
  200: AreaResponseDto;
};

export type UpdateAreaResponse = UpdateAreaResponses[keyof UpdateAreaResponses];

export type AssignContainerToAreaData = {
  body?: never;
  path: {
    areaId: number;
    containerId: number;
  };
  query?: never;
  url: "/api/areas/{areaId}/container/{containerId}";
};

export type AssignContainerToAreaErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type AssignContainerToAreaError = AssignContainerToAreaErrors[keyof AssignContainerToAreaErrors];

export type AssignContainerToAreaResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type AssignContainersToAreaData = {
  body: AssignContainersToAreaDto;
  path: {
    areaId: number;
  };
  query?: never;
  url: "/api/areas/{areaId}/containers";
};

export type AssignContainersToAreaErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type AssignContainersToAreaError = AssignContainersToAreaErrors[keyof AssignContainersToAreaErrors];

export type AssignContainersToAreaResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type ListArticlesData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/articles";
};

export type ListArticlesErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type ListArticlesError = ListArticlesErrors[keyof ListArticlesErrors];

export type ListArticlesResponses = {
  /**
   * OK
   */
  200: ApiResponseListArticleDto;
};

export type ListArticlesResponse = ListArticlesResponses[keyof ListArticlesResponses];

export type CreateArticleData = {
  body: ArticleDto;
  path?: never;
  query?: never;
  url: "/api/articles";
};

export type CreateArticleErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type CreateArticleError = CreateArticleErrors[keyof CreateArticleErrors];

export type CreateArticleResponses = {
  /**
   * OK
   */
  200: ApiResponseInteger;
};

export type CreateArticleResponse = CreateArticleResponses[keyof CreateArticleResponses];

export type GetContactsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/contacts";
};

export type GetContactsErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetContactsError = GetContactsErrors[keyof GetContactsErrors];

export type GetContactsResponses = {
  /**
   * OK
   */
  200: Array<ContactResponseDto>;
};

export type GetContactsResponse = GetContactsResponses[keyof GetContactsResponses];

export type CreateContactData = {
  body: ContactCreateDto;
  path?: never;
  query?: never;
  url: "/api/contacts";
};

export type CreateContactErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type CreateContactError = CreateContactErrors[keyof CreateContactErrors];

export type CreateContactResponses = {
  /**
   * Created
   */
  201: CreateContactResponseDto;
};

export type CreateContactResponse = CreateContactResponses[keyof CreateContactResponses];

export type GetContactByIdData = {
  body?: never;
  path: {
    contactId: number;
  };
  query?: never;
  url: "/api/contacts/{contactId}";
};

export type GetContactByIdErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetContactByIdError = GetContactByIdErrors[keyof GetContactByIdErrors];

export type GetContactByIdResponses = {
  /**
   * OK
   */
  200: ContactResponseDto;
};

export type GetContactByIdResponse = GetContactByIdResponses[keyof GetContactByIdResponses];

export type UpdateContactByIdData = {
  body: ContactCreateDto;
  path: {
    contactId: number;
  };
  query?: never;
  url: "/api/contacts/{contactId}";
};

export type UpdateContactByIdErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type UpdateContactByIdError = UpdateContactByIdErrors[keyof UpdateContactByIdErrors];

export type UpdateContactByIdResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GetContainerTypesData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/container-types";
};

export type GetContainerTypesErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetContainerTypesError = GetContainerTypesErrors[keyof GetContainerTypesErrors];

export type GetContainerTypesResponses = {
  /**
   * OK
   */
  200: ContainerTypeListResponseDto;
};

export type GetContainerTypesResponse = GetContainerTypesResponses[keyof GetContainerTypesResponses];

export type CreateContainerTypeData = {
  body: ContainerTypeRequestDto;
  path?: never;
  query?: never;
  url: "/api/container-types";
};

export type CreateContainerTypeErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type CreateContainerTypeError = CreateContainerTypeErrors[keyof CreateContainerTypeErrors];

export type CreateContainerTypeResponses = {
  /**
   * OK
   */
  200: ContainerTypeResponseDto;
};

export type CreateContainerTypeResponse = CreateContainerTypeResponses[keyof CreateContainerTypeResponses];

export type DeleteContainerTypeData = {
  body?: never;
  path: {
    containerTypeId: number;
  };
  query?: never;
  url: "/api/container-types/{containerTypeId}";
};

export type DeleteContainerTypeErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type DeleteContainerTypeError = DeleteContainerTypeErrors[keyof DeleteContainerTypeErrors];

export type DeleteContainerTypeResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GetContainerTypeData = {
  body?: never;
  path: {
    containerTypeId: number;
  };
  query?: never;
  url: "/api/container-types/{containerTypeId}";
};

export type GetContainerTypeErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetContainerTypeError = GetContainerTypeErrors[keyof GetContainerTypeErrors];

export type GetContainerTypeResponses = {
  /**
   * OK
   */
  200: ContainerTypeResponseDto;
};

export type GetContainerTypeResponse = GetContainerTypeResponses[keyof GetContainerTypeResponses];

export type UpdateContainerTypeData = {
  body: ContainerTypeRequestDto;
  path: {
    containerTypeId: number;
  };
  query?: never;
  url: "/api/container-types/{containerTypeId}";
};

export type UpdateContainerTypeErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type UpdateContainerTypeError = UpdateContainerTypeErrors[keyof UpdateContainerTypeErrors];

export type UpdateContainerTypeResponses = {
  /**
   * OK
   */
  200: ContainerTypeResponseDto;
};

export type UpdateContainerTypeResponse = UpdateContainerTypeResponses[keyof UpdateContainerTypeResponses];

export type GetContainersData = {
  body?: never;
  path?: never;
  query?: {
    containerIds?: Array<number>;
    containerNames?: Array<string>;
  };
  url: "/api/containers";
};

export type GetContainersErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetContainersError = GetContainersErrors[keyof GetContainersErrors];

export type GetContainersResponses = {
  /**
   * OK
   */
  200: GetContainerListResponseDto;
};

export type GetContainersResponse = GetContainersResponses[keyof GetContainersResponses];

export type CreateContainerData = {
  body: CreateContainerRequestDto;
  path?: never;
  query?: never;
  url: "/api/containers";
};

export type CreateContainerErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type CreateContainerError = CreateContainerErrors[keyof CreateContainerErrors];

export type CreateContainerResponses = {
  /**
   * OK
   */
  200: GetContainerResponseDto;
};

export type CreateContainerResponse = CreateContainerResponses[keyof CreateContainerResponses];

export type CreateContainersData = {
  body: CreateContainerBatchRequestDto;
  path?: never;
  query?: never;
  url: "/api/containers/batch";
};

export type CreateContainersErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type CreateContainersError = CreateContainersErrors[keyof CreateContainersErrors];

export type CreateContainersResponses = {
  /**
   * OK
   */
  200: GetContainerListResponseDto;
};

export type CreateContainersResponse = CreateContainersResponses[keyof CreateContainersResponses];

export type GetContainerByIdData = {
  body?: never;
  path: {
    containerId: number;
  };
  query?: never;
  url: "/api/containers/{containerId}";
};

export type GetContainerByIdErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetContainerByIdError = GetContainerByIdErrors[keyof GetContainerByIdErrors];

export type GetContainerByIdResponses = {
  /**
   * OK
   */
  200: GetContainerResponseDto;
};

export type GetContainerByIdResponse = GetContainerByIdResponses[keyof GetContainerByIdResponses];

export type UpdateContainerData = {
  body: UpdateContainerRequestDto;
  path: {
    containerId: number;
  };
  query?: never;
  url: "/api/containers/{containerId}";
};

export type UpdateContainerErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type UpdateContainerError = UpdateContainerErrors[keyof UpdateContainerErrors];

export type UpdateContainerResponses = {
  /**
   * OK
   */
  200: GetContainerResponseDto;
};

export type UpdateContainerResponse = UpdateContainerResponses[keyof UpdateContainerResponses];

export type AddContentToContainerData = {
  body: AddContentRequestDto;
  path: {
    containerId: number;
  };
  query?: never;
  url: "/api/containers/{containerId}/content";
};

export type AddContentToContainerErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type AddContentToContainerError = AddContentToContainerErrors[keyof AddContentToContainerErrors];

export type AddContentToContainerResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type DeleteContentBatchWithoutCheckData = {
  body: ContainerEmptyBatchDto;
  path?: never;
  query?: never;
  url: "/api/content";
};

export type DeleteContentBatchWithoutCheckErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type DeleteContentBatchWithoutCheckError =
  DeleteContentBatchWithoutCheckErrors[keyof DeleteContentBatchWithoutCheckErrors];

export type DeleteContentBatchWithoutCheckResponses = {
  /**
   * OK
   */
  200: GetContainerListResponseDto;
};

export type DeleteContentBatchWithoutCheckResponse =
  DeleteContentBatchWithoutCheckResponses[keyof DeleteContentBatchWithoutCheckResponses];

export type AddContentToContainerBatchData = {
  body: ContainerAddContentBatchDto;
  path?: never;
  query?: never;
  url: "/api/content/batch";
};

export type AddContentToContainerBatchErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type AddContentToContainerBatchError = AddContentToContainerBatchErrors[keyof AddContentToContainerBatchErrors];

export type AddContentToContainerBatchResponses = {
  /**
   * OK
   */
  200: GetContainerListResponseDto;
};

export type AddContentToContainerBatchResponse =
  AddContentToContainerBatchResponses[keyof AddContentToContainerBatchResponses];

export type ChangeContentLevelBatchData = {
  body: ContentLevelBatchDto;
  path?: never;
  query?: never;
  url: "/api/content/level/batch";
};

export type ChangeContentLevelBatchErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type ChangeContentLevelBatchError = ChangeContentLevelBatchErrors[keyof ChangeContentLevelBatchErrors];

export type ChangeContentLevelBatchResponses = {
  /**
   * OK
   */
  200: GetContainerListResponseDto;
};

export type ChangeContentLevelBatchResponse = ChangeContentLevelBatchResponses[keyof ChangeContentLevelBatchResponses];

export type ListExternalSystemsSettingsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/external/settings/external-system";
};

export type ListExternalSystemsSettingsErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type ListExternalSystemsSettingsError =
  ListExternalSystemsSettingsErrors[keyof ListExternalSystemsSettingsErrors];

export type ListExternalSystemsSettingsResponses = {
  /**
   * OK
   */
  200: ApiResponseListExternalSystemSettingsResponseDto;
};

export type ListExternalSystemsSettingsResponse =
  ListExternalSystemsSettingsResponses[keyof ListExternalSystemsSettingsResponses];

export type StoreExternalSystemSettingsData = {
  body: StoreExternalSystemSettingsRequestDto;
  path?: never;
  query?: never;
  url: "/api/external/settings/external-system";
};

export type StoreExternalSystemSettingsErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type StoreExternalSystemSettingsError =
  StoreExternalSystemSettingsErrors[keyof StoreExternalSystemSettingsErrors];

export type StoreExternalSystemSettingsResponses = {
  /**
   * Created
   */
  201: ApiResponseExternalSystemSettingsResponseDto;
};

export type StoreExternalSystemSettingsResponse =
  StoreExternalSystemSettingsResponses[keyof StoreExternalSystemSettingsResponses];

export type TriggerSyncData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/external/settings/external-system/sync";
};

export type TriggerSyncErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type TriggerSyncError = TriggerSyncErrors[keyof TriggerSyncErrors];

export type TriggerSyncResponses = {
  /**
   * OK
   */
  200: ApiResponseContactSyncResultDto;
};

export type TriggerSyncResponse = TriggerSyncResponses[keyof TriggerSyncResponses];

export type DeleteExternalSystemSettingsData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: "/api/external/settings/external-system/{id}";
};

export type DeleteExternalSystemSettingsErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type DeleteExternalSystemSettingsError =
  DeleteExternalSystemSettingsErrors[keyof DeleteExternalSystemSettingsErrors];

export type DeleteExternalSystemSettingsResponses = {
  /**
   * No Content
   */
  204: ApiResponseUnit;
};

export type DeleteExternalSystemSettingsResponse =
  DeleteExternalSystemSettingsResponses[keyof DeleteExternalSystemSettingsResponses];

export type UpdateExternalSystemSettingsData = {
  body: UpdateExternalSystemSettingsRequestDto;
  path: {
    id: string;
  };
  query?: never;
  url: "/api/external/settings/external-system/{id}";
};

export type UpdateExternalSystemSettingsErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type UpdateExternalSystemSettingsError =
  UpdateExternalSystemSettingsErrors[keyof UpdateExternalSystemSettingsErrors];

export type UpdateExternalSystemSettingsResponses = {
  /**
   * OK
   */
  200: ApiResponseExternalSystemSettingsResponseDto;
};

export type UpdateExternalSystemSettingsResponse =
  UpdateExternalSystemSettingsResponses[keyof UpdateExternalSystemSettingsResponses];

export type GetMeData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/iam/me";
};

export type GetMeErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetMeError = GetMeErrors[keyof GetMeErrors];

export type GetMeResponses = {
  /**
   * OK
   */
  200: UserDto;
};

export type GetMeResponse = GetMeResponses[keyof GetMeResponses];

export type StartPasswordResetData = {
  body: PasswordResetRequestDto;
  path?: never;
  query?: never;
  url: "/api/iam/password-reset";
};

export type StartPasswordResetErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type StartPasswordResetError = StartPasswordResetErrors[keyof StartPasswordResetErrors];

export type StartPasswordResetResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type ConfirmPasswordResetData = {
  body: PasswordResetConfirmationRequestDto;
  path?: never;
  query?: never;
  url: "/api/iam/password-reset/confirm";
};

export type ConfirmPasswordResetErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type ConfirmPasswordResetError = ConfirmPasswordResetErrors[keyof ConfirmPasswordResetErrors];

export type ConfirmPasswordResetResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type SignInData = {
  body: SignInRequestDto;
  path?: never;
  query?: never;
  url: "/api/iam/sign-in";
};

export type SignInErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type SignInError = SignInErrors[keyof SignInErrors];

export type SignInResponses = {
  /**
   * OK
   */
  200: ApiErrorContainer;
};

export type SignInResponse = SignInResponses[keyof SignInResponses];

export type SignOutData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/iam/sign-out";
};

export type SignOutErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type SignOutError = SignOutErrors[keyof SignOutErrors];

export type SignOutResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type SignUpData = {
  body: SignUpRequestDto;
  path?: never;
  query?: never;
  url: "/api/iam/sign-up";
};

export type SignUpErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type SignUpError = SignUpErrors[keyof SignUpErrors];

export type SignUpResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type ConfirmSignUpData = {
  body?: never;
  path: {
    token: string;
  };
  query?: never;
  url: "/api/iam/sign-up/confirm/{token}";
};

export type ConfirmSignUpErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type ConfirmSignUpError = ConfirmSignUpErrors[keyof ConfirmSignUpErrors];

export type ConfirmSignUpResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GetVersionData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/info/version";
};

export type GetVersionErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetVersionError = GetVersionErrors[keyof GetVersionErrors];

export type GetVersionResponses = {
  /**
   * OK
   */
  200: VersionResponseDto;
};

export type GetVersionResponse = GetVersionResponses[keyof GetVersionResponses];

export type SendConfirmationMailData = {
  body: ConfirmationMailDto;
  path?: never;
  query?: never;
  url: "/api/mail/confirmation";
};

export type SendConfirmationMailErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type SendConfirmationMailError = SendConfirmationMailErrors[keyof SendConfirmationMailErrors];

export type SendConfirmationMailResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GetOrdersData = {
  body?: never;
  path?: never;
  query?: {
    scheduledDeliveryDateFrom?: string;
    scheduledDeliveryDateTo?: string;
  };
  url: "/api/orders";
};

export type GetOrdersErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetOrdersError = GetOrdersErrors[keyof GetOrdersErrors];

export type GetOrdersResponses = {
  /**
   * OK
   */
  200: ApiResponseListOrderDto;
};

export type GetOrdersResponse = GetOrdersResponses[keyof GetOrdersResponses];

export type CreateOrderData = {
  body: OrderCreateDto;
  path?: never;
  query?: never;
  url: "/api/orders";
};

export type CreateOrderErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type CreateOrderError = CreateOrderErrors[keyof CreateOrderErrors];

export type CreateOrderResponses = {
  /**
   * OK
   */
  200: ApiResponseString;
};

export type CreateOrderResponse = CreateOrderResponses[keyof CreateOrderResponses];

export type UnscheduleDeliveryData = {
  body?: never;
  path?: never;
  query: {
    orderNumber: string;
  };
  url: "/api/orders/delivery-schedule";
};

export type UnscheduleDeliveryErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type UnscheduleDeliveryError = UnscheduleDeliveryErrors[keyof UnscheduleDeliveryErrors];

export type UnscheduleDeliveryResponses = {
  /**
   * OK
   */
  200: ApiResponseUnit;
};

export type UnscheduleDeliveryResponse = UnscheduleDeliveryResponses[keyof UnscheduleDeliveryResponses];

export type GetDeliveryScheduleData = {
  body?: never;
  path?: never;
  query: {
    startDate: string;
    endDate: string;
  };
  url: "/api/orders/delivery-schedule";
};

export type GetDeliveryScheduleErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetDeliveryScheduleError = GetDeliveryScheduleErrors[keyof GetDeliveryScheduleErrors];

export type GetDeliveryScheduleResponses = {
  /**
   * OK
   */
  200: ApiResponseListOrderDeliveryScheduleDto;
};

export type GetDeliveryScheduleResponse = GetDeliveryScheduleResponses[keyof GetDeliveryScheduleResponses];

export type ScheduleDeliveryData = {
  body: OrderDeliveryScheduleDto;
  path?: never;
  query?: never;
  url: "/api/orders/delivery-schedule";
};

export type ScheduleDeliveryErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type ScheduleDeliveryError = ScheduleDeliveryErrors[keyof ScheduleDeliveryErrors];

export type ScheduleDeliveryResponses = {
  /**
   * OK
   */
  200: ApiResponseUnit;
};

export type ScheduleDeliveryResponse = ScheduleDeliveryResponses[keyof ScheduleDeliveryResponses];

export type GetOrderData = {
  body?: never;
  path: {
    orderNumber: string;
  };
  query?: never;
  url: "/api/orders/{orderNumber}";
};

export type GetOrderErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetOrderError = GetOrderErrors[keyof GetOrderErrors];

export type GetOrderResponses = {
  /**
   * OK
   */
  200: ApiResponseOrderDto;
};

export type GetOrderResponse = GetOrderResponses[keyof GetOrderResponses];

export type UpdateOrderData = {
  body: OrderUpdateDto;
  path: {
    orderNumber: string;
  };
  query?: never;
  url: "/api/orders/{orderNumber}";
};

export type UpdateOrderErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type UpdateOrderError = UpdateOrderErrors[keyof UpdateOrderErrors];

export type UpdateOrderResponses = {
  /**
   * OK
   */
  200: ApiResponseUnit;
};

export type UpdateOrderResponse = UpdateOrderResponses[keyof UpdateOrderResponses];

export type GetPriceOverridesData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/price-overrides";
};

export type GetPriceOverridesErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetPriceOverridesError = GetPriceOverridesErrors[keyof GetPriceOverridesErrors];

export type GetPriceOverridesResponses = {
  /**
   * OK
   */
  200: PriceOverrideContainerDto;
};

export type GetPriceOverridesResponse = GetPriceOverridesResponses[keyof GetPriceOverridesResponses];

export type SetPriceOverridesData = {
  body: PriceOverrideContainerDto;
  path?: never;
  query?: never;
  url: "/api/price-overrides";
};

export type SetPriceOverridesErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type SetPriceOverridesError = SetPriceOverridesErrors[keyof SetPriceOverridesErrors];

export type SetPriceOverridesResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GetPriceSettingsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/price-settings";
};

export type GetPriceSettingsErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetPriceSettingsError = GetPriceSettingsErrors[keyof GetPriceSettingsErrors];

export type GetPriceSettingsResponses = {
  /**
   * OK
   */
  200: PriceSettingsDto;
};

export type GetPriceSettingsResponse = GetPriceSettingsResponses[keyof GetPriceSettingsResponses];

export type SetPriceSettingsData = {
  body: PriceSettingsRequestDto;
  path?: never;
  query?: never;
  url: "/api/price-settings";
};

export type SetPriceSettingsErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type SetPriceSettingsError = SetPriceSettingsErrors[keyof SetPriceSettingsErrors];

export type SetPriceSettingsResponses = {
  /**
   * OK
   */
  200: unknown;
};

export type GetPricesData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/prices";
};

export type GetPricesErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetPricesError = GetPricesErrors[keyof GetPricesErrors];

export type GetPricesResponses = {
  /**
   * OK
   */
  200: PriceContainerDto;
};

export type GetPricesResponse = GetPricesResponses[keyof GetPricesResponses];

export type GetCuttingLengthsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/settings/cutting-lengths";
};

export type GetCuttingLengthsErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetCuttingLengthsError = GetCuttingLengthsErrors[keyof GetCuttingLengthsErrors];

export type GetCuttingLengthsResponses = {
  /**
   * OK
   */
  200: CuttingLengthContainerDto;
};

export type GetCuttingLengthsResponse = GetCuttingLengthsResponses[keyof GetCuttingLengthsResponses];

export type GetHumidityLevelsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/settings/humidity-levels";
};

export type GetHumidityLevelsErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetHumidityLevelsError = GetHumidityLevelsErrors[keyof GetHumidityLevelsErrors];

export type GetHumidityLevelsResponses = {
  /**
   * OK
   */
  200: HumidityLevelContainerDto;
};

export type GetHumidityLevelsResponse = GetHumidityLevelsResponses[keyof GetHumidityLevelsResponses];

export type GetWoodTypesData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/settings/wood-types";
};

export type GetWoodTypesErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetWoodTypesError = GetWoodTypesErrors[keyof GetWoodTypesErrors];

export type GetWoodTypesResponses = {
  /**
   * OK
   */
  200: WoodTypeContainerDto;
};

export type GetWoodTypesResponse = GetWoodTypesResponses[keyof GetWoodTypesResponses];

export type GetContainerStatisticsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/statistics/containers";
};

export type GetContainerStatisticsErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetContainerStatisticsError = GetContainerStatisticsErrors[keyof GetContainerStatisticsErrors];

export type GetContainerStatisticsResponses = {
  /**
   * OK
   */
  200: ContainerStatisticsDto;
};

export type GetContainerStatisticsResponse = GetContainerStatisticsResponses[keyof GetContainerStatisticsResponses];

export type GetContentLevelEventStatisticsData = {
  body?: never;
  path?: never;
  query?: {
    withNulls?: boolean;
    startDate?: string;
    endDate?: string;
  };
  url: "/api/statistics/content";
};

export type GetContentLevelEventStatisticsErrors = {
  /**
   * Bad Request
   */
  400: ApiErrorContainer;
  /**
   * Unauthorized
   */
  401: ApiErrorContainer;
  /**
   * Access denied
   */
  403: unknown;
  /**
   * Not Found
   */
  404: ApiErrorContainer;
  /**
   * Internal Server Error
   */
  500: ApiErrorContainer;
};

export type GetContentLevelEventStatisticsError =
  GetContentLevelEventStatisticsErrors[keyof GetContentLevelEventStatisticsErrors];

export type GetContentLevelEventStatisticsResponses = {
  /**
   * OK
   */
  200: ContentLevelEventStatisticsDto;
};

export type GetContentLevelEventStatisticsResponse =
  GetContentLevelEventStatisticsResponses[keyof GetContentLevelEventStatisticsResponses];
